import { createStoreHook } from "@xstate/store/react";

const useLayoutStore = createStoreHook({
  context: {
    isFullscreen: false,
    isMenuCollapsed: false,
    isMobileMenuOpen: false,
  },

  on: {
    toggleFullscreen: (context) => ({
      ...context,
      isFullscreen: !context.isFullscreen,
    }),
    setFullscreen: (context, event: { value: boolean }) => ({
      ...context,
      isFullscreen: event.value,
    }),
    toggleMenuCollapse: (context) => ({
      ...context,
      isMenuCollapsed: !context.isMenuCollapsed,
    }),
    setMenuCollapse: (context, event: { value: boolean }) => ({
      ...context,
      isMenuCollapsed: event.value,
    }),
    toggleMobileMenu: (context) => ({
      ...context,
      isMobileMenuOpen: !context.isMobileMenuOpen,
    }),
    setMobileMenuOpen: (context, event: { value: boolean }) => ({
      ...context,
      isMobileMenuOpen: event.value,
    }),
  },
});

export default useLayoutStore;
